<template>
	<div>

	</div>
</template>

<script>
	import {
		authorizeLogin
	} from '@/api/login'
	import {
		setToken,getToken
	} from '@/tool/cookie'
	import router from '@/router'
	import Qs from 'qs'
	export default {
		data() {
			return {
				query:{},
				text:'授权登录中，请稍等。。。。。',
			}
		},
		created() {
			let query = this.$route.query;
			this.query = query;
			this.login();
		},
		methods: {
			login(){
				const loading = this.$loading({
					lock: true,
					text: this.text,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				// 如果本身已经登录了，跳转进登录页面
				if(getToken('login_uid')){
					//  跳转到首页
					this.$router.push('/')
				}else{
					authorizeLogin(Qs.stringify(this.query)).then(response => {
						// 存储商家的uid和token
						setToken('admin_name', response.result.user_name);
						setToken('login_uid', response.result.id);
						setToken('token', response.result.token);
						//  跳转到首页
						this.$router.push('/')
					})
				}
				loading.close();
			}
		}
	}
</script>

<style>
</style>
